(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  if (window.prlxPush && window.innerWidth > 768) {
    const collectionGrid = document.getElementById('CollectionProductGrid');

    if (collectionGrid) {
      new MutationObserver(() => {
        window.prlxPush(collectionGrid.querySelectorAll('[data-js-prlx-parent]'));
      }).observe(collectionGrid, {
        attributes: false,
        childList: true,
        subtree: false
      });
    }
  }

  document.addEventListener(
    'click',
    (e) => {
      const removeBtn = e.target.closest('.active-facets__remove');
      const clearAllBtn = e.target.closest('.active-facets__clear, [data-clear-all]');

      if (!removeBtn && !clearAllBtn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (removeBtn) {
        const value = removeBtn.dataset.value;
        if (!value) return;

        const checkbox = document.querySelector(
          `.facets input[type="checkbox"][value="${CSS.escape(value)}"]`
        );

        if (checkbox) {
          checkbox.checked = false;
        }
      }

      if (clearAllBtn) {
        document
          .querySelectorAll('.facets input[type="checkbox"]:checked')
          .forEach(input => {
            input.checked = false;
          });
      }
    },
    true
  );

  onReady(() => {
    const filter = document.getElementById('site-filters-sidebar');
    const sort = document.getElementById('site-sort-sidebar');

    if (filter) document.body.append(filter);
    if (sort) document.body.append(sort);
  });

  onReady(() => {
    const btn = document.querySelector('.collection-btn--filter');
    if (!btn) return;

    let countEl = btn.querySelector('.filter-count');

    if (!countEl) {
      countEl = document.createElement('span');
      countEl.className = 'filter-count';
      btn.appendChild(countEl);
    }

    function update() {
      const pills = document.querySelectorAll('.active-facets .pill').length;

      if (pills > 0) {
        countEl.textContent = ` (${pills})`;
        countEl.style.display = 'inline';
      } else {
        countEl.textContent = '';
        countEl.style.display = 'none';
      }
    }

    update();

    const target = document.querySelector('.active-facets');
    if (!target) return;

    new MutationObserver(update).observe(target, {
      childList: true,
      subtree: true
    });
  });

  onReady(() => {
    const btn = document.querySelector('.header-collection-btn--filter');
    if (!btn) return;

    let countEl = btn.querySelector('.filter-count');

    if (!countEl) {
      countEl = document.createElement('span');
      countEl.className = 'filter-count';
      btn.appendChild(countEl);
    }

    function update() {
      const facetsContainers = document.querySelectorAll('.active-facets');
      let count = 0;

      facetsContainers.forEach(el => {
        const pills = el.querySelectorAll('.pill').length;
        if (pills > 0) count = pills;
      });

      if (count > 0) {
        countEl.textContent = ` (${count})`;
        countEl.style.display = 'inline';
      } else {
        countEl.textContent = '';
        countEl.style.display = 'none';
      }
    }

    update();

    const observer = new MutationObserver(update);

    document.querySelectorAll('.active-facets').forEach(el => {
      observer.observe(el, {
        childList: true,
        subtree: true
      });
    });
  });

  onReady(() => {
    const btn = document.querySelector('.header-collection-btn--sort');
    if (!btn) return;

    let labelEl = btn.querySelector('.sort-label');

    if (!labelEl) {
      labelEl = document.createElement('span');
      labelEl.className = 'sort-label';
      btn.appendChild(labelEl);
    }

    function getCurrentSortLabel() {
      const selects = document.querySelectorAll('select[name="sort_by"]');

      for (const select of selects) {
        if (select.options.length) {
          const selected = select.options[select.selectedIndex];

          if (selected && selected.text) {
            return selected.text.trim();
          }
        }
      }

      return null;
    }

    function update() {
      const label = getCurrentSortLabel();

      if (!label) {
        labelEl.textContent = '';
        labelEl.style.display = 'none';
        return;
      }

      if (label.toLowerCase().includes('featured') || label.toLowerCase().includes('manual')) {
        labelEl.textContent = '';
        labelEl.style.display = 'none';
        return;
      }

      labelEl.textContent = ` (${label})`;
      labelEl.style.display = 'inline';
    }

    update();

    document.addEventListener('change', (e) => {
      if (e.target.matches('select[name="sort_by"]')) {
        update();
      }
    });

    document.addEventListener('click', () => {
      setTimeout(update, 50);
    });
  });
})();